import React from 'react'
import FileStructure from './FileStructure'
import Hamburger from '../Extra/HamBurg'
import styled from 'styled-components'
import Worktable from './Worktable'
import { motion } from 'framer-motion'

const Work = () => {
  return (
    <FileStructure>
      <Hamburger />

      <WorkMainDiv>

        <WorkHeader>
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              ease: [0.65, 0, 0.35, 1],
              duration: 1,
              delay: 1
            }}
            className="headTitle">
            <h1 className='heading'> Project panorama </h1>
            <h1 className='heading'> A glimpse into my work </h1>
          </motion.div>
        </WorkHeader>

        <Worktable />

      </WorkMainDiv>


    </FileStructure>
  )
}

export default Work

const WorkMainDiv = styled.div`

`
const WorkHeader = styled.div`
  padding: 23vh 10vh 0;
  margin: auto;
  width: 80%;
  
  @media only screen and (max-width: 1260px) {
    padding: 23vh 5vh 0 !important;

      h1{
        font-size: 4rem !important; 
      }
  }


@media only screen and (max-width: 1040px) {
  padding: 23vh 0 0 !important;
}

  @media only screen and (max-width: 900px) {
    h1{
      font-size: 3.5rem !important; 
    }
  }
  @media only screen and (max-width: 835px) {
    width: 90% !important;
  }

@media only screen and (max-width: 720px) {
  h1{
    font-size: 3rem !important; 
  }
}

@media only screen and (max-width: 645px) {
  h1{
    font-size: 2.5rem !important; 
  }
}

@media only screen and (max-width: 520px) {
  h1{
    font-size: 2rem !important; 
  }
}

@media only screen and (max-width: 430px) {
  h1{
    font-size: 1.75rem !important; 
  }
}


  .headTitle{
    display: flex;
    gap: 2rem;
    flex-direction: column;

    h1{
      font-size: 5.5rem; 
      font-weight: 500; 
      font-family: var(--font7);
    }
  }
`